module.exports = __webpack_public_path__ + "static/img/蒙版组 40.14b0742.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inAndOut/cancelled/images/蒙版组 40.png
// module id = FSmB
// module chunks = 0